export function toUrlSafe(str) {
    str = str.toLowerCase().replace(' ','-');
    return str
}
